const EMOJI_REGEX5 =
  /(?![*#0-9]+)[\p{Emoji}\p{Emoji_Modifier}\p{Emoji_Component}\p{Emoji_Modifier_Base}\p{Emoji_Presentation}]\s*/gu;

/**
 * This method removes emojis from a text. It is
 * used for string sorting purposes for instance
 * @param {string} text
 * @returns
 */
export default function (text) {
  return text.replace(EMOJI_REGEX5, '').trim();
}
